var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BasicImage,{class:[
    _vm.disabled ? 'selectable-image-disabled' : 'selectable-image',
    { 'is-selected': _setup.selected },
  ],attrs:{"src":_vm.src,"alt":"Some Image"},nativeOn:{"click":function($event){return _setup.handleClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }